
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinema-online",
      function () {
        return require("private-next-pages/cinema-online.tsx");
      }
    ]);
  